<template>
  <div class="lower-z-index mt-3" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
    <div class="col-md-12 col-sm-12 mb-4">
      <div class="text-center">
        <b-button variant="secondary" @click="$emit('back')">{{ $t('back') }}</b-button>
        <b-button v-if="showNext" :disabled="disabled" variant="primary gray default" type="submit">{{ nextText }}</b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    idx: {
      type: Number,
      default: 0
    },
    maxSteps: {
      type: Number,
      default: 1
    },
    showNext: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    nextText() {
      if (this.idx < this.maxSteps) {
        return this.$t('next')
      }
      return this.$t('finish')
    }
  }
}
</script>
